import Vue from "vue";
import VueI18n from "vue-i18n";
import * as constants from "./constants"


Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: constants.DEFAULT_LOCATE,
  fallbackLocale: constants.DEFAULT_LOCATE,
  messages: {
    vi: require("../locales/vi.json"),
    en: require("../locales/en.json")
  }
});
export default i18n;